import { reportDefinitionsApi, type ReportDefinitionGroup, type ReportDefinitionTenant } from './api';
import type { ReportDefinitionsBoard } from './report-definitions-board.svelte';
import type { ReportLineDraft } from './report-line-draft.svelte';
import type { ReportLineWriter } from './report-line-writer';

/** A linha de cliente nova num conjunto: o modelo e os canais vêm do conjunto, a linha traz horário e contatos. */
export class ReportDefinitionCreator implements ReportLineWriter {
  busy = $state(false);
  private readonly board: ReportDefinitionsBoard;
  private readonly group: ReportDefinitionGroup;
  private readonly tenant: ReportDefinitionTenant;

  constructor(line: { board: ReportDefinitionsBoard; group: ReportDefinitionGroup; tenant: ReportDefinitionTenant }) {
    this.board = line.board;
    this.group = line.group;
    this.tenant = line.tenant;
  }

  async save(draft: ReportLineDraft): Promise<boolean> {
    if (!draft.isComplete) return false;
    this.busy = true;
    try {
      await reportDefinitionsApi.create(this.tenant.tenantId, {
        reportDefinitionGroupId: this.group.id,
        schedule: draft.schedule.toSchedule(),
        recipients: draft.toRecipients(),
      });
      await this.board.load();
      return true;
    } catch (err) {
      this.board.fail(err);
      return false;
    } finally {
      this.busy = false;
    }
  }
}
